import request from '@/utils/request'

//
export function materialCategoryList(params) {
  return request({
    url: '/materialCategory/treeList',
    method: 'get',
   
    params
  })
}



export function materialCategoryDelete(params) {
  return request({
    url: '/materialCategory/delete',
    method: 'get',
   
    params
  })
}
export function associated(params) {
  return request({
    url: '/materialCategory/associated',
    method: 'get',
   
    params
  })
}

export function materialList(params) {
  return request({
    url: '/material/model/page',
    method: 'get',
   
    params
  })
}
export function materialCategoryAdd(params) {
  return request({
    url: '/materialCategory/add',
    method: 'post',
   
    data: params
  })
}

export function materialCategoryEdit(params) {
  return request({
    url: '/materialCategory/edit',
    method: 'post',
   
    data: params
  })
}
export function materialDetil(params) {
  return request({
    url: '/material/model/findById',
    method: 'get',
   
    params
  })
}
export function materialUpdateStatus(params) {
  return request({
    url: '/material/model/updateStatus',
    method: 'get',
   
    params
  })
}

export function materialDelete(params) {
  return request({
    url: '/material/model/delete',
    method: 'get',
   
    params
  })
}

export function tbMaterialSpecList(params) {
  return request({
    url: '/tbMaterialSpec/page',
    method: 'get',
   
    params
  })
}

export function tbMaterialSpecDelete(params) {
  return request({
    url: '/tbMaterialSpec/delete',
    method: 'get',
   
    params
  })
}
export function listHx(params) {
  return request({
    url: '/orderType/listHx',
    method: 'get',
   
    params
  })
}
export function tbMaterialSpeclistSelect(params) {
  return request({
    url: '/tbMaterialSpec/list',
    method: 'get',
   
    params
  })
}
export function tbMaterialModelArchivesSnList(data) {
  return request({
    url: '/tbMaterialModelArchivesSn/page',
    method: 'post',
   
    data
  })
}
export function tbMaterialModelArchivesSnDelete(params) {
  return request({
    url: '/tbMaterialModelArchivesSn/delete',
    method: 'get',
   
    params
  })
}
export function tbBillCalculationRecord(params) {
  return request({
    url: '/tbBillCalculationRecord/page',
    method: 'get',
   
    params
  })
}
export function getZTCategoryList(params) {
  return request({
    url: '/material/model/getZTCategoryList',
    method: 'get',
   
    params
  })
}
export function getZTCategoryTemplateList(params) {
  return request({
    url: '/material/model/getZTCategoryTemplateList',
    method: 'get',
   
    params
  })
}
export function materialSave(params) {
  return request({
    url: '/material/model/save',
    method: 'post',
   
    data: params
  })
}
export function tbMaterialSpecSave(params) {
  return request({
    url: '/tbMaterialSpec/save',
    method: 'post',
   
    data: params
  })
}
export function tbMaterialSpecUpdate(params) {
  return request({
    url: '/tbMaterialSpec/update',
    method: 'post',
   
    data: params
  })
}

export function materialUpdate(params) {
  return request({
    url: '/material/model/update',
    method: 'post',
   
    data: params
  })
}
export function tbMaterialModelArchivesSave(params) {
  return request({
    url: '/tbMaterialModelArchivesSn/save',
    method: 'post',
   
    data: params
  })
}
export function tbMaterialModelArchivesUpdata(params) {
  return request({
    url: '/tbMaterialModelArchivesSn/update',
    method: 'post',
   
    data: params
  })
}
export function getDicts(params) {
  return request({
    prefix: 'gasDataCenter',
    url: '/gasDict/findDictTree',
    method: 'get',
   
    params
  })
}
export function listSnStatus(params) {
  return request({
    url: '/tbMaterialModelArchivesSn/listSnStatus',
    method: 'get',
   
    params
  })
}
export function brandCategoryTreeList(params) {
  return request({
    url: '/brandCategory/treeList',
    method: 'get',
   
    params
  })
}
export function brandCategoryDelete(params) {
  return request({
    url: '/brandCategory/delete',
    method: 'get',
   
    params
  })
}
export function brandCategoryEdit(params) {
  return request({
    url: '/brandCategory/edit',
    method: 'post',
   
    data: params
  })
}
export function brandCategoryAdd(params) {
  return request({
    url: '/brandCategory/add',
    method: 'post',
   
    data: params
  })
}
// /tbMaterialModelArchivesSn/importVerificationCodes
export function importVerificationCodes(data) {
  return request({
    url: '/tbMaterialModelArchivesSn/importVerificationCodes',
    method: 'post',
    data,
    ContentType: 'multipart/form-data'
  })
}